/** **************************************************************************************************
 * Action Fresh
 *************************************************************************************************** */
export const PAGE_REQUEST_FRESH = 'PAGE_REQUEST_FRESH';
export const SET_IS_ELIGIBLE_FRESH = 'SET_IS_ELIGIBLE_FRESH';
export const SHOW_MODAL_FRESH = 'SHOW_MODAL_FRESH';
export const HIDE_MODAL_FRESH = 'HIDE_MODAL_FRESH';
export const SUBMIT_FORM_FRESH = 'SUBMIT_FORM_FRESH';
